import {useCallback} from 'react';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {useConstant} from '../../../../srcCommon/helpers/hookHelpers';
import {useAppDispatch, useAppSelector} from '../../../helpers/reduxHelpers';
import {toggleExpandItemAction} from './localPreferencesActions';
import {makeGetFindIsExpanded} from './localPreferencesSelectors';

export function useExpandItem(key: string, defaultValue: boolean): [boolean, Handler] {
  const dispatch = useAppDispatch();

  const getFindIsExpanded = useConstant(() => makeGetFindIsExpanded(key, defaultValue));
  const isExpanded = useAppSelector(getFindIsExpanded);

  const toggleExpanded = useCallback(
    () => dispatch(toggleExpandItemAction(key, defaultValue)),
    [defaultValue, dispatch, key],
  );

  return [isExpanded, toggleExpanded];
}
